// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateSouthAfricanDocument(document: string): ?UserInputValidationError {
  if (!document || document.trim() === '')
    return { id: 'empty' };
  else if (!/^[a-zA-Z0-9]{13}$/.test(document))
    return { id: 'invalid-pattern' };
}
